import Vue from 'vue'

export async function fetchWelcomeUsers({ commit }) {
  try {
    const { data } = await Vue.axios({ 
      url: '/frontend/welcome' 
    })
    commit('setWelcomeUsers', data)
  } catch (error) {
    commit('welcomesError', error.message)
  } finally {
    // console.log('la peticion de bienvenidos de los usuarios ha finalizado')
  }
}